export default "__VITE_ASSET__BVppT8GD__"